export default "/kiban/_next/static/images/almThickness-299d27f507ca7f369156145a206b6597.png";